import { render, staticRenderFns } from "./QuestEdit.vue?vue&type=template&id=4230b0b2&scoped=true&"
import script from "./QuestEdit.vue?vue&type=script&lang=js&"
export * from "./QuestEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuestEdit.vue?vue&type=style&index=0&id=4230b0b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4230b0b2",
  null
  
)

export default component.exports